import { useOrg } from '../lib/org'
import { ScheduleScreen } from './ScheduleScreen'

/**
 * Schedule, signed in. This only answers which congregation is being looked
 * at, which on this side is the one chosen once in the app shell. The public
 * page sets the same resolved schedule in a reader's layout of its own.
 */
export function OccasionPage() {
  const { orgs, spaceId } = useOrg()

  return (
    <div className="page">
      <ScheduleScreen
        spaceId={spaceId}
        shul={orgs.find((o) => o.spaceId === spaceId)}
      />
    </div>
  )
}
